import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MailSenderService } from 'src/app/mail-sender.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'],
})
export class ContactComponent implements OnInit {
  createContactForm: FormGroup;

  /**
   * Constructor
   */
  constructor(
    private _formBuilder: FormBuilder,
    private mailSenderService: MailSenderService
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Create the form
    this.createContactForm = this._formBuilder.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.email, Validators.required]],
      subject: ['', [Validators.required]],
      message: ['', [Validators.required]],
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Send the message
   */
  send(): void {
    if (this.createContactForm.valid) {
      this.createContactForm.disable();
      const newRequest = {
        name: this.createContactForm.get('name').value,
        email: this.createContactForm.get('email').value,
        subject: this.createContactForm.get('subject').value,
        message: this.createContactForm.get('message').value,
      };
      console.log(newRequest);
      this.mailSenderService.sendMail(newRequest).subscribe(
        (res) => {},
        (err) => {}
      );
    } else {
      this.createContactForm.markAllAsTouched();
    }
  }
}
